export default "/images/a2e1a268eb6d32f726ae1bb6ffdf1ae3.avif";